import { useMemo, useState } from 'react'
import moment, { Moment } from 'moment'
import { getCurrentIanaTimezone } from '@/utils'
import { ScheduledSessionOfUser } from '@/AppContext'
import { getSessionsInWindow } from '@/pages/ScheduleSessionPage/ScheduleSessionLogic'
import { useTranslation } from 'react-i18next'

const WINDOW_DAYS = 7

export default function useScheduledSessionsFilter(sessions: ScheduledSessionOfUser[]) {
    const { t } = useTranslation()
    const [tWindowStartDate, setTWindowStartDate] = useState<Moment>(moment())
    const [windowLabel, setWindowLabel] = useState<string>(t('This Week'))
    const currTimeZone = getCurrentIanaTimezone()

    const handleNextWeek = () => {
        setTWindowStartDate((curr) => {
            const nextStart = moment(curr).add(WINDOW_DAYS, 'day')
            setWindowLabel(
                `${nextStart.format('MMM D')} - ${moment(nextStart).add(WINDOW_DAYS, 'day').format('MMM D')}`
            )
            return nextStart
        })
    }
    const handlePrevWeek = () => {
        setTWindowStartDate((curr) => {
            const nextStart = moment(curr).add(-WINDOW_DAYS, 'day')
            setWindowLabel(
                `${nextStart.format('MMM D')} - ${moment(nextStart).add(WINDOW_DAYS, 'day').format('MMM D')}`
            )
            return nextStart
        })
    }
    const handleToday = () => {
        setTWindowStartDate(moment())
        setWindowLabel(t('This Week'))
    }

    const sessionsInWindow = useMemo(() => {
        const sessionWindowStartDate = moment(tWindowStartDate).startOf('day').toDate()
        const sessionWindowEndDate = moment(tWindowStartDate)
            .add(WINDOW_DAYS - 1, 'days')
            .endOf('day')
            .toDate()

        // NOTE: Ideally this should be moved to when sessions are fetched, not during render
        return getSessionsInWindow(sessions, sessionWindowStartDate, sessionWindowEndDate, currTimeZone)
    }, [sessions, tWindowStartDate, currTimeZone])

    const sessionsToday = useMemo(() => {
        const sessionWindowStartDate = moment(moment()).startOf('day').toDate()
        const sessionWindowEndDate = moment(moment()).add(1, 'days').endOf('day').toDate()

        // NOTE: Ideally this should be moved to when sessions are fetched, not during render
        return getSessionsInWindow(sessions, sessionWindowStartDate, sessionWindowEndDate, currTimeZone)
    }, [sessions, currTimeZone])

    return {
        sessionsInWindow,
        sessionsToday,
        windowLabel,
        handleToday,
        handleNextWeek,
        handlePrevWeek,
    }
}
